import { render, staticRenderFns } from "./PersonalAreaCheckboxList.vue?vue&type=template&id=d811388a&scoped=true&"
import script from "./PersonalAreaCheckboxList.vue?vue&type=script&lang=js&"
export * from "./PersonalAreaCheckboxList.vue?vue&type=script&lang=js&"
import style0 from "./PersonalAreaCheckboxList.vue?vue&type=style&index=0&id=d811388a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d811388a",
  null
  
)

export default component.exports